const core = {
    namespaced: true,

    state: {},

    getters: {},
    actions: {},
    mutations: {}
};


export default core;

